module.exports = __webpack_public_path__ + "static/img/cont40_04.ea5e5b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont40_04.jpg
// module id = c1Vf
// module chunks = 0